import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import styles from "../../../assets/styles/componentStyles/billingStyles/planSubscribedPopup.module.scss";

import GlobalPopUp from "../../utility/globalPopUp";
import GlobalButton from "../../utility/globalButton/button";
import useGenericHook from "../../../hooks/useGenericHook";

interface BillingInfoPopupProps {
    open: boolean;
    onClose: () => void;
    title: string;
    description: string;
    buttonText?: string;
    showCloseIcon?: boolean;
    onClickOfBtn?: () => void;
}

const BillingInfoPopup = ({ open, onClose, title, description, buttonText, showCloseIcon = false, onClickOfBtn }: BillingInfoPopupProps) => {

    const { isScreenBelow600 } = useGenericHook();

    return (
        <GlobalPopUp
            open={open}
            onClose={onClose}
            handleClose={onClose}
            flagShowCloseIcon={showCloseIcon}
            flagBackdrop
            titlePadding="5px"
            borderRadius="16px"
            paperMinWidth={isScreenBelow600 ? "300px" : "400px"}
            paperMaxwidth={isScreenBelow600 ? "350px" : "450px"}
        >
            <Box className={styles.content}>
                <Box className={styles.iconWrap}>
                    <InfoOutlinedIcon className={styles.icon} />
                </Box>

                <Typography className={styles.title}>
                    {title}
                </Typography>

                <Typography className={styles.description}>
                    {description}
                </Typography>

                {buttonText && (
                    <GlobalButton
                        buttonText={buttonText}
                        className="primaryButtonStyle"
                        onClick={onClickOfBtn}
                        sx={{ margin: "8px 0 0 0", minWidth: "100px" }}
                    />
                )}
            </Box>
        </GlobalPopUp>
    );
};

export default BillingInfoPopup;
